import React, { HTMLAttributes } from 'react'
import { MobileBodyNotScroll, MobileBodyNotScrollForm, ScrollWrapper } from 'src/shared/ui/mobile/ui-page.styled'

export interface ScrollBodyProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any
    scrollRef?: React.RefObject<HTMLDivElement>
    attributes?: HTMLAttributes<HTMLFormElement>
}

export const ScrollBody = (props: ScrollBodyProps) => {
    return (
        <ScrollWrapper ref={props.scrollRef}>
            <MobileBodyNotScroll role="main">{props.children}</MobileBodyNotScroll>
        </ScrollWrapper>
    )
}

export const ScrollBodyForm = (props: ScrollBodyProps) => {
    return (
        <ScrollWrapper ref={props.scrollRef}>
            <MobileBodyNotScrollForm role="main" {...props.attributes}>
                {props.children}
            </MobileBodyNotScrollForm>
        </ScrollWrapper>
    )
}
